import { useState } from 'react';
import Carousel from '../Carousel';
import styles from '../../styles/Gallery.module.css';
import GalleryItem from '../GalleryItem';
import { GalleryItemData } from '../../lib/types/data/gallery-item-data';

interface GalleryProps {
  items: GalleryItemData[];
}

export default function Gallery({ items }: GalleryProps) {
  const [selectedItem, setSelectedItem] = useState(items[0]);

  return (
    <div className={styles.boxImagesWrapper}>
      <GalleryItem className={styles.selectedItem} data={selectedItem} />
      <div className={styles.boxItemContainer}>
        <Carousel
          arrows
          dots
          draggable
          variant="toy-list"
          slidesToShow={4}
          slidesToShowXl={4}
          slidesToShowLg={3}
          slidesToShowMd={3}
          slidesToShowSm={2}
          centerModeMobile={false}
          centerMode={false}
          centerPadding="48px"
        >
          {items.map((item) => (
            <div
              key={item.src}
              className={
                selectedItem.src === item.src
                  ? styles.selectedImg
                  : styles.imgWrapper
              }
            >
              <img
                className={styles.carouselImage}
                src={item.src}
                alt={item.alt}
                onClick={() => setSelectedItem(item)}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
}
